import React, { useState } from 'react';
import DisputeLetterModal from '../components/DisputeLetterModal';

/**
 * Demo/Preview page for the Dispute Letter modal — lets you exercise
 * the 4-step wizard directly without going through the FTC Builder
 * flow.  Prefilled with a realistic mix of accounts across categories.
 */
export default function DisputeLetterDemoPage() {
  const [open, setOpen] = useState(true);

  const clientName = 'John Q Public';
  const clientAddressLines = ['123 Main St', 'Anytown, CA 90210', '555-123-4567'];
  const defaultAccountsStructured = [
    { account_name: 'CAPITAL ONE', category: 'CREDIT_CARD', date_opened: '07-2023', balance: '472' },
    { account_name: 'DISCOVER',    category: 'CREDIT_CARD', date_opened: '01-2022', balance: '1250' },
    { account_name: 'CHASE AUTO',  category: 'AUTO',        date_opened: '03-2020', balance: '12500' },
    { account_name: 'LVNV FUNDING',category: 'COLLECTION',                          balance: '1001' },
    { account_name: 'NAVIENT',     category: 'STUDENT_LOAN',                        balance: '18000' },
  ];

  return (
    <div className="min-h-screen bg-slate-950 text-white p-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Dispute Letter Generator — Demo</h1>
        <p className="text-slate-400 mb-6 text-sm">
          Preview the 4-step wizard. Prefilled with 5 accounts across 4 categories.
        </p>
        <button
          onClick={() => setOpen(true)}
          className="bg-gradient-to-br from-fuchsia-600 to-purple-700 hover:from-fuchsia-500 hover:to-purple-600 text-white text-sm font-semibold py-3 px-5 rounded-xl shadow-md shadow-fuchsia-900/40 transition-colors"
          data-testid="open-dispute-demo-btn"
        >
          Open Dispute Letter Wizard
        </button>
      </div>
      <DisputeLetterModal
        open={open}
        onClose={() => setOpen(false)}
        clientName={clientName}
        clientAddressLines={clientAddressLines}
        defaultAccountsStructured={defaultAccountsStructured}
      />
    </div>
  );
}
